<template>
  <div class="selection" v-if="options?.length">
    <ObSelection
      v-model="sortType"
      :options="options"
      :showOverlay="true"
      @select="switchType"
    />
  </div>
  <ObList
    ref="obListRef"
    :load="getExploreList"
  >
    <component 
      v-for="(item, index) in list"
      :key="item.id"
      :is="item.components" 
      :cardInfo="item"
      :showTag="!!item?.circleInfo?.id"
      :index="index"
      :showStick="Boolean(item.stick)"
    />
  </ObList>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useSystemStore } from '@/stores/system'

const systemStore = useSystemStore()  // 用户仓库
const { exploreSortMenuSwitch } = storeToRefs(systemStore)   // 用户id
const { proxy } = getCurrentInstance()

const obListRef = ref(null)

const sortType = ref(1)

const list = ref([])

const options = computed(() => {
  let allMenu = [{
    label: proxy.$t('homePage.recommended'),
    name: 'recommended',
    value: 1
  },{
    label: proxy.$t('homePage.daily'),
    name: 'day',
    value: 3
  },{
    label: proxy.$t('homePage.weekly'),
    name: 'week',
    value: 2
  },{
    label: proxy.$t('homePage.latest'),
    name: 'newest',
    value: 4
  }]
  const showMap = Object.keys(exploreSortMenuSwitch.value).filter(i => !!exploreSortMenuSwitch.value[i] )
  allMenu = allMenu.filter(i => showMap.includes(i.name))
  sortType.value = allMenu[0] ? allMenu[0].value : []
  return allMenu
})

function switchType () {
  list.value = []
  obListRef.value.onRefresh()
}

async function getExploreList (params) {
  const { pageData = {
    page: 1,
    limit: 20
  } } = params || {}
  const { code, data, msg} = await proxy.$http.getExploreList({
    ...pageData,
    type: sortType.value
  })
  let finished = false
  if (code === 200 && data) {
    const { rows, total } = data || {}
    for(const i of rows) {
      switch (i.type) {
        case 1:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/articleCard.vue')))
          break
        case 2:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/momentCard.vue')))
          break
        case 4:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/pollCard.vue')))
          break
        default:
      }
    }
    list.value = [...list.value, ...rows]
    finished = list.value.length >= total || !rows?.length
  }
  return {
    code,
    finished
  }
}

</script>

<style lang="postcss" scoped>
.selection {
  margin-top: 12px;
}
</style>